export default function(product){
    return `Hrana za ${product}`;

    
}
